// Loader.js
import React from 'react';
import './Loader.css'; // Optional: for styling the loader

function Loader() {
  return (
    <div className="loader-container">
      <div className="spinner"></div>
    </div>
  );
}

export default Loader;
